import { ThemeDefinition } from "vuetify";

export const kraftanmelding: ThemeDefinition = {
  dark: false,
  colors: {
    // Layout
    background: "#f5faff",
    surface: "#FFFFFF",
    menubg: "#FFFFFF",
    navbarbg: "#FFFFFF",

    // Semantic
    primary: "#66a3d9", // A calm blue for primary actions
    secondary: "#E0E0E0", // Light grey for secondary
    success: "#4CAF50",
    warning: "#FFC107",
    error: "#F44336",
    info: "#2196F3",

    // Charts (simple, muted palette)
    charts0: "#66a3d9",
    charts1: "#90caf9",
    charts2: "#bdbdbd",
    charts3: "#a5d6a7",
    charts4: "#ffe082",
    charts5: "#ce93d8",
    charts6: "#ffab91",
    charts7: "#fff59d",
    charts8: "#80cbc4",
    charts9: "#ef9a9a",
    charts10: "#b2dfdb",

    // Text
    "on-background": "#222222",
    "on-surface": "#222222",
    "on-primary": "#FFFFFF",
    "on-menubg": "#222222",
    "on-navbarbg": "#222222",

    // Custom brand tokens
    blue: "#0055A4",
    white: "#FFFFFF",
    grey: "#E0E0E0",
    green: "#4CAF50",
    yellow: "#FFC107",
    red: "#F44336",

    // Blue variants
    "light-blue": "#66a3d9",
    "blue-lighten-1": "#3380cc",
    "blue-lighten-2": "#66a3d9",
    "blue-lighten-3": "#99c6e6",
    "blue-lighten-4": "#cce9f2",
    "blue-lighten-5": "#e6f4fa",
    "blue-darken-1": "#004080",
    "blue-darken-2": "#003366",
    "blue-darken-3": "#00264d",
    "blue-darken-4": "#001933",
    "blue-darken-5": "#000d1a",

    // Grey variants
    "grey-lighten-1": "#f5f5f5",
    "grey-lighten-2": "#eeeeee",
    "grey-lighten-3": "#e0e0e0",
    "grey-lighten-4": "#bdbdbd",
    "grey-lighten-5": "#9e9e9e",
    "grey-darken-1": "#757575",
    "grey-darken-2": "#616161",
    "grey-darken-3": "#424242",
    "grey-darken-4": "#212121",
    "grey-darken-5": "#111111",
  },
};
